<div class="miscellaneous-form-container">
  <div class="info-note">
    <app-information-note
      [message]="miscInfoText"
      *ngIf="miscInfoText"></app-information-note>
  </div>
  <div class="mawb-misc-form" [formGroup]="mawbMiscForm">
    <mat-form-field appearance="outline" class="mat-md">
      <mat-label>Clearance Agent</mat-label>
      <input
        id="clearanceAgent"
        appOnOptionSelectedTabNewInput
        matInput
        formControlName="clearanceAgent"
        placeholder="Enter Agent Code and Name"
        [matAutocomplete]="agentAutoComplete"
        (input)="
          formAutocompleteValueChanges(
            'clearanceAgent',
            'receivingAgent',
            agentData,
            'clearanceAgent'
          )
        " />
      <mat-autocomplete
        #agentAutoComplete="matAutocomplete"
        (optionSelected)="
          onOptionSelectedFormChanges(
            agentData,
            'clearanceAgent',
            'receivingAgent'
          )
        "
        appOnOptionSelectedTabNewInput
        [controlId]="'clearanceAgent'">
        <mat-option *ngFor="let item of filteredAgentOptions | async" [value]="item.name">
          {{ item.name }}
        </mat-option>
      </mat-autocomplete>
      <app-field-clear-suffix
        matSuffix
        [control]="mawbMiscForm.get('clearanceAgent')"
        [autocomplete]="true" />
      <app-svg-icon
        *ngIf="checkControlHasError('clearanceAgent')"
        matSuffix
        [iconName]="'infoCircle'"
        [isStaticSvg]="true"
        [isFrom]="'Page'"
        class="cursor info-icon-error"
        (click)="fetchWidth($event, 'clearanceAgent')"
        (keydown)="$event.stopPropagation()"></app-svg-icon>
      <app-custom-error-tooltip
        *ngIf="
          checkControlHasError('clearanceAgent') &&
          setMawbMiscInfoErrorTooltip['clearanceAgent']
        "
        [tooltipWidth]="setMawbMiscInfoWidth['clearanceAgent']"
        [tooltipText]="getErrorMessage('clearanceAgent')"
        (tooltipCloseClicked)="
          commonService.closeErrorTooltip(
            'clearanceAgent',
            setMawbMiscInfoErrorTooltip
          )
        "></app-custom-error-tooltip>
    </mat-form-field>
    <mat-form-field appearance="outline" class="mat-md">
      <mat-label>Linehaul Charge</mat-label>
      <input
        matInput
        formControlName="linehaulCharge"
        (input)="dispatchMiscellaneousMawbFormValueChanges()" />
    </mat-form-field>
  </div>

  <!-- PAC-24713: read-only US CBP Entry Numbers (outside the form, so it stays clickable in View mode) -->
  @if (isMawbInformationScreen) {
    <div class="cbp-entry-numbers-panel">
      <div class="cbp-entry-numbers-title">
        <span class="ibc-body-text-medium-bold">
          {{ cbpMessages.usCbpEntryNumbersLabel }}:
        </span>
        <!-- Badge per Figma: green "Available" / red "Not Available" (create mode = Not Available) -->
        <span
          class="cbp-status-badge"
          [class.cbp-status-available]="showCbpEntryNumbersLink"
          [class.cbp-status-not-available]="!showCbpEntryNumbersLink">
          {{
            showCbpEntryNumbersLink
              ? cbpMessages.usCbpEntryNumbersAvailable
              : cbpMessages.usCbpEntryNumbersNotAvailableBadge
          }}
        </span>
      </div>
      @if (showCbpEntryNumbersLink) {
        <button
          type="button"
          class="cbp-entry-numbers-link"
          (click)="openCbpEntryNumbersPopup()">
          {{ visibleCbpEntryNumbers }}
          @if (remainingCbpEntryNumbersCount > 0) {
            <span
              class="cbp-entry-numbers-others"
              [matTooltip]="cbpMessages.usCbpEntryNumbersOthersTooltip"
              matTooltipPosition="above">
              +{{ remainingCbpEntryNumbersCount }} others
            </span>
          }
        </button>
      } @else {
        <span class="cbp-entry-numbers-empty">
          {{ cbpMessages.usCbpEntryNumbersNoEntries }}
        </span>
      }
    </div>
  }
</div>
